import React from "react";
import { ModuleContext, useModuleContext } from "@qlik/qlik/src/context/ModuleContext";
import DefaultPlaceholder from "@qlik/qlik/src/components/DefaultPlaceholder";
import Hero_Banner_Home from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Home";
import Hero_Banner_Image from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Image";
import Hero_Banner_No_Image from "@qlik/qlik/src/components/CardContainer/Hero_Banner_No_Image";
import Hero_Banner_No_Image_v2 from "@qlik/qlik/src/components/CardContainer/Hero_Banner_No_Image_v2";
import CTA_Background_Image from "@qlik/qlik/src/components/CardContainer/CTA_Background_Image";
import Promo_Card_Video from "@qlik/qlik/src/components/CardContainer/Promo_Card_Video";
import Promo_Card_No_image from "@qlik/qlik/src/components/CardContainer/Promo_Card_No_image";
import CTA_Horizontal from "@qlik/qlik/src/components/CardContainer/CTA_Horizontal";
import CTA_Background_Grey from "@qlik/qlik/src/components/CardContainer/CTA_Background_Grey";
import Content_Image from "@qlik/qlik/src/components/CardContainer/Content_Image";
import Card_With_List_Items from "@qlik/qlik/src/components/CardContainer/Card_With_List_Items";
import Card_Image_Wide from "@qlik/qlik/src/components/CardContainer/Card_Image_Wide";
import Content_Image_Left_Align from "@qlik/qlik/src/components/CardContainer/Content_Image_Left_Align";
import Home_Tab_Slider from "@qlik/qlik/src/components/CardDeckContainer/Home_Tab_Slider";
import Home_Hero_Cards from "@qlik/qlik/src/components/CardDeckContainer/Home_Hero_Cards";
import Logo_Carousel from "@qlik/qlik/src/components/CardDeckContainer/Logo_Carousel";
import Horizontal_Card_Stack from "@qlik/qlik/src/components/CardDeckContainer/Horizontal_Card_Stack";
import Slider_News from "@qlik/qlik/src/components/CardDeckContainer/Slider_News";
import Resource_Cards from "@qlik/qlik/src/components/CardDeckContainer/Resource_Cards";
import Event_Cards from "@qlik/qlik/src/components/CardDeckContainer/Event_Cards";
import Home_Slider from "@qlik/qlik/src/components/CardDeckContainer/Home_Slider";
import Quote from "@qlik/qlik/src/components/CardContainer/Quote";
import Tab_Slider_Quotes from "@qlik/qlik/src/components/CardDeckContainer/Tab_Slider_Quotes";
import Card_Image from "@qlik/qlik/src/components/CardDeckContainer/Card_Image";
import Card_Module_Partial_UI from "@qlik/qlik/src/components/CardDeckContainer/Card_Module_Partial_UI";
import Card_With_Full_Image from "@qlik/qlik/src/components/CardDeckContainer/Card_With_Full_Image";
import Content_Images from "@qlik/qlik/src/components/CardDeckContainer/Content_Images";
import Content_Animation from "@qlik/qlik/src/components/CardDeckContainer/Content_Animation";
import Content_Images_Background from "@qlik/qlik/src/components/CardDeckContainer/Content_Images_Background";
import Content_Icons from "@qlik/qlik/src/components/CardDeckContainer/Content_Icons";
import Slider_Quotes from "@qlik/qlik/src/components/CardDeckContainer/Slider_Quotes";
import Awards from "@qlik/qlik/src/components/CardDeckContainer/Awards";
import Promo_Card_Background_Color from "@qlik/qlik/src/components/CardContainer/Promo_Card_Background_Color";
import Image_Content_Left_Right from "@qlik/qlik/src/components/CardContainer/Image_Content_Left_Right";
import Left_and_Right_Image_Half from "@qlik/qlik/src/components/CardContainer/Left_and_Right_Image_Half";
import Product_Module_Left_Right from "@qlik/qlik/src/components/CardContainer/Product_Module_Left_Right";
import Card_Icon from "@qlik/qlik/src/components/CardDeckContainer/Card_Icon";
import Card_Module_With_Shadow from "@qlik/qlik/src/components/CardDeckContainer/Card_Module_With_Shadow";
import Card_With_Background from "@qlik/qlik/src/components/CardDeckContainer/Card_With_Background";
import Card_White_Background_Two_Col from "@qlik/qlik/src/components/CardDeckContainer/Card_White_Background_Two_Col";
import Stats from "@qlik/qlik/src/components/CardDeckContainer/Stats";
import Promo_Card from "@qlik/qlik/src/components/CardContainer/Promo_Card";
import Headshot_Small from "@qlik/qlik/src/components/CardDeckContainer/Headshot_Small";
import Headline_Paragraph from "@qlik/qlik/src/components/CardContainer/Headline_Paragraph";
import Headshot_Larger from "@qlik/qlik/src/components/CardDeckContainer/Headshot_Larger";
import Partners from "@qlik/qlik/src/components/CardDeckContainer/Partners";
import Promo_Card_Full_Width from "@qlik/qlik/src/components/CardContainer/Promo_Card_Full_Width";
import Card_Two_Column from "@qlik/qlik/src/components/CardDeckContainer/Card_Two_Column";
import Inner_Page_Navigation from "@qlik/qlik/src/components/CardContainer/Inner_Page_Navigation";
import Page_Navigation from "@qlik/qlik/src/components/CardContainer/Page_Navigation";
import Bio from "@qlik/qlik/src/components/CardContainer/Bio";
import Inner_Page_Navigation_Vertical from "@qlik/qlik/src/components/CardContainer/Inner_Page_Navigation_Vertical";
import Glossary_List from "@qlik/qlik/src/components/CardDeckContainer/Glossary_List";
import Left_Aligned_Content from "@qlik/qlik/src/components/RichTextContainer/Left_Aligned_Content";
import Centered_Content from "@qlik/qlik/src/components/RichTextContainer/Centered_Content";
import Table_Of_Content_Intro from "@qlik/qlik/src/components/CardContainer/Table_Of_Content_Intro";
import Table_Design from "@qlik/qlik/src/components/CardContainer/Table_Design";
import Card_Locations from "@qlik/qlik/src/components/CardDeckContainer/Card_Locations";
import Quote_With_Image from "@qlik/qlik/src/components/CardContainer/Quote_With_Image";
import Card_Dark_Background from "@qlik/qlik/src/components/CardDeckContainer/Card_Dark_Background";
import Icon_Cards_Two_Columns from "@qlik/qlik/src/components/CardDeckContainer/Icon_Cards_Two_Columns";
import Clickable_Image_Component from "@qlik/qlik/src/components/CardDeckContainer/Clickable_Image_Component";
import Card_Text_Form from "@qlik/qlik/src/components/CardDeckContainer/Card_Text_Form";
import Gartner_Cards from "@qlik/qlik/src/components/CardDeckContainer/Gartner_Cards";
import Horizontal_CTA_Image from "@qlik/qlik/src/components/CardContainer/Horizontal_CTA_Image";
import Horizontal_CTA_Document from "@qlik/qlik/src/components/CardContainer/Horizontal_CTA_Document";
import Resource from "@qlik/qlik/src/components/CardContainer/Listing/Resource";
import Find_Partner_Custom_Script from "@qlik/qlik/src/components/CardContainer/Find_Partner_Custom_Script";
import StandardMarketoForm from "@qlik/qlik/src/components/CardDeckContainer/StandardMarketoForm";
import Gated_Content from "@qlik/qlik/src/components/CardDeckContainer/Gated_Content";
import Accordion from "@qlik/qlik/src/components/CardDeckContainer/Accordion";
import Event from "@qlik/qlik/src/components/CardContainer/Listing/Event";
import Form_Wide from "@qlik/qlik/src/components/CardDeckContainer/Form_Wide";
import PastEvents from "@qlik/qlik/src/components/CardContainer/Listing/Event/PastEvents";
import News from "@qlik/qlik/src/components/CardContainer/Listing/News";
import Promo_Card_Resource from "@qlik/qlik/src/components/CardContainer/Promo_Card_Resource";
import Blog from "@qlik/qlik/src/components/CardContainer/Listing/Blog";
import Jobs from "@qlik/qlik/src/components/CardContainer/Listing/Jobs";
import Hero_Banner_Large_Frame from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Large_Frame";
import Hero_Banner_Quote from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Quote";
import Full_Width_Section_Icons_Left_Right from "@qlik/qlik/src/components/CardDeckContainer/Full_Width_Section_Icons_Left_Right";
import Fixed_Image_Scrolling_Text from "@qlik/qlik/src/components/CardDeckContainer/Fixed_Image_Scrolling_Text";
import Hero_Banner_Center_Image from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Center_Image";
import Tabs_Scrolling_Section from "@qlik/qlik/src/components/CardDeckContainer/Tabs_Scrolling_Section";
import Hero_Banner_Logo_Slider from "@qlik/qlik/src/components/CardDeckContainer/Hero_Banner_Logo_Slider";
import Offering_Panels from "@qlik/qlik/src/components/CardDeckContainer/Offering_Panels/OfferingPanels";
import Full_Width_Media_Cards from "@qlik/qlik/src/components/CardDeckContainer/Full_Width_Media_Cards";
import Card_Left_Align_Title_Button from "@qlik/qlik/src/components/CardDeckContainer/Card_Left_Align_Title_Button";
import Client_Slider from "@qlik/qlik/src/components/CardDeckContainer/Client_Slider";
import Single_Quote_Dark from "@qlik/qlik/src/components/CardDeckContainer/Single_Quote_Dark";
import DataSource from "@qlik/qlik/src/components/CardContainer/Listing/DataSource";
import Logo_Wall_Sliding from "@qlik/qlik/src/components/CardDeckContainer/Logo_Wall_Sliding";
import Single_Quote from "@qlik/qlik/src/components/CardContainer/Single_Quote";
import PricingCards from "@qlik/qlik/src/components/CardDeckContainer/PricingCards/PricingCards";
import Three_Content_Blocks_With_Buttons from "@qlik/qlik/src/components/CardDeckContainer/Three_Content_Blocks_With_Buttons";
import Horizontal_CTA_Background_Color from "@qlik/qlik/src/components/CardContainer/Horizontal_CTA_Background_Color";
import Customer_Card_Slider from "@qlik/qlik/src/components/CardDeckContainer/Customer_Card_Slider";
import PricingFeatureTable from "@qlik/qlik/src/components/CardDeckContainer/PricingFeatureTable/PricingFeatureTable";
import Page_Content from "@qlik/qlik/src/components/CardDeckContainer/Page_Content";
import Gated_Content_Small_Form from "@qlik/qlik/src/components/CardDeckContainer/Gated_Content_Small_Form";
import Gartner_Insights from "@qlik/qlik/src/components/CardContainer/Gartner_Insights";
import Tab_Slider_Quotes_Without_Images from "@qlik/qlik/src/components/CardDeckContainer/Tab_Slider_Quotes_Without_Images";
import Resource_Section_Title_Right_Aligned_CTA from "@qlik/qlik/src/components/CardContainer/Resource_Section_Title_Right_Aligned_CTA";
import Card_List_Mobile_Slider from "@qlik/qlik/src/components/CardDeckContainer/Card_List_Mobile_Slider";
import Card_Border_With_Shadow from "@qlik/qlik/src/components/CardDeckContainer/Card_Border_With_Shadow";
import Legal_Content from "@qlik/qlik/src/components/RichTextContainer/Legal_Content";
import Legal_Cards from "@qlik/qlik/src/components/CardDeckContainer/Legal_Cards";
import Card_With_Links from "@qlik/qlik/src/components/CardDeckContainer/Card_With_Links";
import Search_Results from "@qlik/qlik/src/components/CardContainer/Search_Results";
import Pricing_Page_Header from "@qlik/qlik/src/components/CardContainer/Pricing_Page_Header";
import Signature from "@qlik/qlik/src/components/CardContainer/Signature";
import Media_With_Cards from "@qlik/qlik/src/components/CardDeckContainer/Media_With_Cards";
import Thank_You from "@qlik/qlik/src/components/CardContainer/Thank_You";
import Parallax_Media_Cards from "@qlik/qlik/src/components/CardDeckContainer/Parallax_Media_Cards";
import Multiplex_Tabbed_Carousel from "@qlik/qlik/src/components/Multiplex/TabbedCarousel/TabbedCarousel";
import Multiplex_Advanced_Accordion from "@qlik/qlik/src/components/Multiplex/MultiAccordion/MultiAccordion";
import Product_Demo from "@qlik/qlik/src/components/CardContainer/Product_Demo/ProductDemo";
import Pricing_Promo from "@qlik/qlik/src/components/CardContainer/Pricing_Promo/PricingPromo";
import LeftRightPromo from "@qlik/qlik/src/components/CardContainer/Left_Right_Promo";
import HeroBento from "@qlik/qlik/src/betaComponents/HeroBento/HeroBento";
import GroupedCards from "@qlik/qlik/src/components/CardDeckContainer/Grouped_Cards";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";

/**
 * Component Registry
 * This object maps Contentful Content Type names and rendering names to their corresponding React components.
 * Components are loaded lazily using React's lazy function and dynamic imports.
 * If a component is not found in the registry, a default placeholder component is used.
 */
const componentRegistry = {
    defaultPlaceholder: DefaultPlaceholder,
    "ContentfulBeta_Hero Bento": HeroBento,
    "ContentfulCardContainer_Bio Card": Bio,
    "ContentfulCardContainer_Blog Listing": Blog,
    "ContentfulCardContainer_CTA (Horizontal Layout)": CTA_Horizontal,
    "ContentfulCardContainer_CTA with Background Image": CTA_Background_Image,
    "ContentfulCardContainer_CTA with Grey Background": CTA_Background_Grey,
    "ContentfulCardContainer_Card Image Wide": Card_Image_Wide,
    "ContentfulCardContainer_Card With List Items": Card_With_List_Items,
    "ContentfulCardContainer_Content with Image": Content_Image,
    "ContentfulCardContainer_Content with Image left Align": Content_Image_Left_Align,
    "ContentfulCardContainer_Data Source Listing": DataSource,
    "ContentfulCardContainer_Event Listing": Event,
    "ContentfulCardContainer_Find a Partner Custom Script": Find_Partner_Custom_Script,
    "ContentfulCardContainer_Gartner Insights": Gartner_Insights,
    "ContentfulCardContainer_Headline Paragraph": Headline_Paragraph,
    "ContentfulCardContainer_Hero Banner for Home": Hero_Banner_Home,
    "ContentfulCardContainer_Hero Banner Large Frame": Hero_Banner_Large_Frame,
    "ContentfulCardContainer_Hero Banner Quote": Hero_Banner_Quote,
    "ContentfulCardContainer_Hero Banner With Image": Hero_Banner_Image,
    "ContentfulCardContainer_Hero Banner With No Image": Hero_Banner_No_Image,
    "ContentfulCardContainer_Hero Banner With No Image v2": Hero_Banner_No_Image_v2,
    "ContentfulCardContainer_Hero Banner with Center Image": Hero_Banner_Center_Image,
    "ContentfulCardContainer_Horizontal CTA with Background Color": Horizontal_CTA_Background_Color,
    "ContentfulCardContainer_Horizontal CTA with Document": Horizontal_CTA_Document,
    "ContentfulCardContainer_Horizontal CTA with image": Horizontal_CTA_Image,
    "ContentfulCardContainer_Image And Content (Left And Right)": Image_Content_Left_Right,
    "ContentfulCardContainer_Inner Page Navigation": Inner_Page_Navigation,
    "ContentfulCardContainer_Inner-Page-Navigation-Vertical": Inner_Page_Navigation_Vertical,
    "ContentfulCardContainer_Job Listing": Jobs,
    "ContentfulCardContainer_Left Right Promo": LeftRightPromo,
    "ContentfulCardContainer_Left and right 1 - (Image - Half Width)": Left_and_Right_Image_Half,
    "ContentfulCardContainer_News Listing": News,
    "ContentfulCardContainer_Page Navigation": Page_Navigation,
    "ContentfulCardContainer_Past Events": PastEvents,
    "ContentfulCardContainer_Pricing Page Header Component": Pricing_Page_Header,
    "ContentfulCardContainer_Pricing Promo Card": Pricing_Promo,
    "ContentfulCardContainer_Product Demo": Product_Demo,
    "ContentfulCardContainer_Product Module (Left and Right)": Product_Module_Left_Right,
    "ContentfulCardContainer_Promo Card": Promo_Card,
    "ContentfulCardContainer_Promo Card (Full Width)": Promo_Card_Full_Width,
    "ContentfulCardContainer_Promo Card (No Image)": Promo_Card_No_image,
    "ContentfulCardContainer_Promo Card (Resource)": Promo_Card_Resource,
    "ContentfulCardContainer_Promo Card Video": Promo_Card_Video,
    "ContentfulCardContainer_Promo Card with Background Color": Promo_Card_Background_Color,
    ContentfulCardContainer_Quote: Quote,
    "ContentfulCardContainer_Quote With Image": Quote_With_Image,
    "ContentfulCardContainer_Quote with Dark Background": Single_Quote,
    "ContentfulCardContainer_Resource Listing": Resource,
    "ContentfulCardContainer_Resource Section Title with Right Aligned CTA": Resource_Section_Title_Right_Aligned_CTA,
    "ContentfulCardContainer_Search Results": Search_Results,
    ContentfulCardContainer_Signature: Signature,
    "ContentfulCardContainer_Table Design": Table_Design,
    "ContentfulCardContainer_Table Of Content Intro": Table_Of_Content_Intro,
    "ContentfulCardContainer_Thank You": Thank_You,
    ContentfulCardDeckContainer_Awards: Awards,
    "ContentfulCardDeckContainer_Card for Accordion": Accordion,
    ContentfulCardDeckContainer_Card: Card_Icon,
    "ContentfulCardDeckContainer_Card (With left align title and button)": Card_Left_Align_Title_Button,
    "ContentfulCardDeckContainer_Card List Mobile Slider": Card_List_Mobile_Slider,
    "ContentfulCardDeckContainer_Card Module Partial UI": Card_Module_Partial_UI,
    "ContentfulCardDeckContainer_Card Module With Shadow": Card_Module_With_Shadow,
    "ContentfulCardDeckContainer_Card Text and Form": Card_Text_Form,
    "ContentfulCardDeckContainer_Card With Background": Card_With_Background,
    "ContentfulCardDeckContainer_Card With Dark Background": Card_Dark_Background,
    "ContentfulCardDeckContainer_Card With Full Image": Card_With_Full_Image,
    "ContentfulCardDeckContainer_Card With Image": Card_Image,
    "ContentfulCardDeckContainer_Card With White Background Two Column": Card_White_Background_Two_Col,
    "ContentfulCardDeckContainer_Cards For Two Columns": Card_Two_Column,
    "ContentfulCardDeckContainer_Cards with Border and Shadow": Card_Border_With_Shadow,
    "ContentfulCardDeckContainer_Client Slider": Client_Slider,
    "ContentfulCardDeckContainer_Clickable Image Component": Clickable_Image_Component,
    "ContentfulCardDeckContainer_Customer Card Slider": Customer_Card_Slider,
    "ContentfulCardDeckContainer_Dark Single Quote": Single_Quote_Dark,
    "ContentfulCardDeckContainer_Event Cards": Event_Cards,
    "ContentfulCardDeckContainer_Fixed Image and Scrolling Text (Left and Right)": Fixed_Image_Scrolling_Text,
    "ContentfulCardDeckContainer_Form (Wide)": Form_Wide,
    "ContentfulCardDeckContainer_Full Width Media with Cards": Full_Width_Media_Cards,
    "ContentfulCardDeckContainer_Full width section with Icons (Left and Right)": Full_Width_Section_Icons_Left_Right,
    "ContentfulCardDeckContainer_Gartner Cards": Gartner_Cards,
    "ContentfulCardDeckContainer_Gated Content": Gated_Content,
    "ContentfulCardDeckContainer_Gated Content with Small Form": Gated_Content_Small_Form,
    "ContentfulCardDeckContainer_Global HQ": Card_Locations,
    "ContentfulCardDeckContainer_Glossary List": Glossary_List,
    "ContentfulCardDeckContainer_Grouped Cards": GroupedCards,
    "ContentfulCardDeckContainer_Headshot (Large)": Headshot_Larger,
    "ContentfulCardDeckContainer_Headshot (Small)": Headshot_Small,
    "ContentfulCardDeckContainer_Hero Banner with Logo Slider": Hero_Banner_Logo_Slider,
    "ContentfulCardDeckContainer_Home Hero Card": Home_Hero_Cards,
    "ContentfulCardDeckContainer_Home Slider": Home_Slider,
    "ContentfulCardDeckContainer_Home Tab Slider": Home_Tab_Slider,
    "ContentfulCardDeckContainer_Horizontal Card Stack": Horizontal_Card_Stack,
    "ContentfulCardDeckContainer_Icon And Content": Content_Icons,
    "ContentfulCardDeckContainer_Icon Cards For Two Columns": Icon_Cards_Two_Columns,
    "ContentfulCardDeckContainer_Image And Content": Content_Images,
    "ContentfulCardDeckContainer_Animation And Content": Content_Animation,
    "ContentfulCardDeckContainer_Image And Content With Background": Content_Images_Background,
    "ContentfulCardDeckContainer_Legal Cards": Legal_Cards,
    "ContentfulCardDeckContainer_Links Section": Card_With_Links,
    "ContentfulCardDeckContainer_Logo Carousel": Logo_Carousel,
    "ContentfulCardDeckContainer_Logo Wall (Sliding)": Logo_Wall_Sliding,
    "ContentfulCardDeckContainer_Media With Cards": Media_With_Cards,
    "ContentfulCardDeckContainer_Offering Panels": Offering_Panels,
    "ContentfulCardDeckContainer_Page Content": Page_Content,
    "ContentfulCardDeckContainer_Parallax Media with Cards": Parallax_Media_Cards,
    ContentfulCardDeckContainer_Partners: Partners,
    "ContentfulCardDeckContainer_Price Feature Table": PricingFeatureTable,
    "ContentfulCardDeckContainer_Pricing Cards": PricingCards,
    "ContentfulCardDeckContainer_Resource Cards": Resource_Cards,
    "ContentfulCardDeckContainer_Slider for News": Slider_News,
    "ContentfulCardDeckContainer_Slider for Quotes": Slider_Quotes,
    "ContentfulCardDeckContainer_Standard Marketo Form": StandardMarketoForm,
    ContentfulCardDeckContainer_Stats: Stats,
    "ContentfulCardDeckContainer_Tab Slider for Quotes": Tab_Slider_Quotes,
    "ContentfulCardDeckContainer_Tab Slider Quotes With Full Width Content": Tab_Slider_Quotes_Without_Images,
    "ContentfulCardDeckContainer_Tabs Scrolling Section": Tabs_Scrolling_Section,
    "ContentfulCardDeckContainer_Three Content Blocks With Buttons": Three_Content_Blocks_With_Buttons,
    "ContentfulMultiplex_Advanced Accordion": Multiplex_Advanced_Accordion,
    "ContentfulMultiplex_Tabbed Carousel": Multiplex_Tabbed_Carousel,
    "ContentfulRichTextContainer_Centered Content": Centered_Content,
    "ContentfulRichTextContainer_Left Aligned Content": Left_Aligned_Content,
    "ContentfulRichTextContainer_Rich text container for Legal content": Legal_Content,
};

/**
 * Render Linked Components
 * This function takes an element and returns the corresponding React component from the component registry.
 * The key for the component is constructed from the typename and frontend component name of the element.
 * If the component is not found in the registry, a default placeholder component is used.
 * @param {object} element - The element to render.
 * @return {React.Component} The corresponding React component.
 */
const renderLinkedComponents = (element, i) => {
    const componentKey = `${element?.__typename}_${element?.frontEndComponent}`;
    let Component = componentRegistry[componentKey] ?? componentRegistry.defaultPlaceholder;

    // Check if we're already inside a ModuleContext (e.g. nested modules in multiplex).
    const moduleContext = useModuleContext();

    if (!Component) return null;

    return (
        <ModuleContext.Provider
            value={moduleContext ?? { i, frontEndComponent: element?.frontEndComponent }}
            key={element?.id}
        >
            <Component data={{ ...element, customId: getTransformedId(element?.customId) }} />
        </ModuleContext.Provider>
    );
};

export { componentRegistry, renderLinkedComponents };
